type LinkAccountMlsRolloutFlag = {
  type: 'allow' | 'deny';
  mlsTypes: string[];
};

export const hasLinkAccountMlsRolloutFeature = (
  mlsTypes: string[],
  flag: LinkAccountMlsRolloutFlag,
) => {
  switch (flag.type) {
    case 'allow':
      return mlsTypes.some(mlsType => flag.mlsTypes.includes(mlsType));
    case 'deny':
      return !mlsTypes.every(mlsType => flag.mlsTypes.includes(mlsType));
    default:
      throw new Error(`Unhandled flag type: ${flag.type satisfies never}`);
  }
};
